<template>
  <b-modal id="processingModal" ref="processingModal" hide-header hide-footer :visible="isProcessing">
    <h4 class="text-center mt-4 bb-4">{{ $t('global.processingRequest') }}</h4>
    <Loader></Loader>
  </b-modal>
</template>

<script>
import Loader from '@/components/Dashboard/Layout/Loader'

export default {
  name: 'processingModal',
  components: { Loader },
  created () {
    this.$bvModal.show('processingModal')
  },
  computed: {
    isProcessing () {
      return this.$store.state.isProcessing
    }
  }
}
</script>
